export default __webpack_public_path__ + "static/media/unknown_team.416558fa.png";